import { render, staticRenderFns } from "./CreateInvestorAccountAuth.vue?vue&type=template&id=0000b3e4"
import script from "./CreateInvestorAccountAuth.vue?vue&type=script&lang=js"
export * from "./CreateInvestorAccountAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports